// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingIndicator_root___Zrv_","fill":"LoadingIndicator_fill__rmFL0"};